// Convert data URL to Blob - more reliable on iOS than fetch()
export function dataURLtoBlob(dataurl) {
  try {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  } catch (error) {
    console.error('Direct blob conversion failed:', error);
    return null;
  }
}

// Compress image if too large
export function compressImage(canvas, quality = 0.8) {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        if (blob && blob.size > 2 * 1024 * 1024) {
          // If still > 2MB, try lower quality
          canvas.toBlob(
            (compressedBlob) => resolve(compressedBlob),
            'image/jpeg',
            0.6
          );
        } else {
          resolve(blob);
        }
      },
      'image/jpeg',
      quality
    );
  });
}

export async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  // Validate input
  if (!imageSrc || imageSrc === 'data:,' || imageSrc.length < 100) {
    throw new Error('Invalid image source');
  }

  // Create image element
  const image = await new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = imageSrc;
    img.onload = () => resolve(img);
    img.onerror = (error) => reject(new Error('Failed to load image'));
  });

  // Validate image dimensions
  if (image.width === 0 || image.height === 0) {
    throw new Error('Invalid image dimensions');
  }

  // Create canvas
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error('Failed to get canvas context');
  }

  // Calculate optimal size for iOS - max 2048px
  let drawWidth = pixelCrop.width;
  let drawHeight = pixelCrop.height;
  
  const maxDimension = 2048;
  if (drawWidth > maxDimension || drawHeight > maxDimension) {
    const ratio = Math.min(maxDimension / drawWidth, maxDimension / drawHeight);
    drawWidth = drawWidth * ratio;
    drawHeight = drawHeight * ratio;
  }

  canvas.width = drawWidth;
  canvas.height = drawHeight;

  // Draw the cropped portion with scaling
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    drawWidth,
    drawHeight
  );

  // Return compressed data URL
  return canvas.toDataURL("image/jpeg", 0.8);
}